const LOCAL_GLOBAL = '@AgrogerWeb';

const storage = {
  user: `${LOCAL_GLOBAL}:user`,
  token: `${LOCAL_GLOBAL}:token`,
  accessToken: `${LOCAL_GLOBAL}:accessToken`,
  refreshToken: `${LOCAL_GLOBAL}:refreshToken`,
  regAtividade: `${LOCAL_GLOBAL}:sobre`,
  colheita: `${LOCAL_GLOBAL}:colheita`,
  medidaPadrao: `${LOCAL_GLOBAL}:medidaPadrao`,
  regMdo: `${LOCAL_GLOBAL}:regMdo`,
  tutorial: `${LOCAL_GLOBAL}:tutorial`,
  folhaBuscarColaborador: `${LOCAL_GLOBAL}:folhaBuscarColaborador`,
  filtersFinancial: `${LOCAL_GLOBAL}:financialFilters`,
  filtersFinancialSearch: `${LOCAL_GLOBAL}:filtersFinancialSearch`,
  filtersFinancialPeriod: `${LOCAL_GLOBAL}:filtersFinancialPeriod`,
  filtersFinancialPagination: `${LOCAL_GLOBAL}:filtersFinancialPagination`,
  filtersFinancialPaginationConta: `${LOCAL_GLOBAL}:filtersFinancialPaginationConta`,
  openFinanceOcultarValores: `${LOCAL_GLOBAL}:openFinanceOcultarValores`,
  talhoesSort: `${LOCAL_GLOBAL}:talhoesSort`,
  talhoesFilters: `${LOCAL_GLOBAL}:talhoesFilters`,
  vendasSortBy: `${LOCAL_GLOBAL}:vendasSortBy`,
  vendasSortOrder: `${LOCAL_GLOBAL}:vendasSortOrder`,
  fazendaAtivaId: `${LOCAL_GLOBAL}:fazendaAtivaId`,
  whatsappSetupDismissed: `${LOCAL_GLOBAL}:whatsappSetupDismissed`,
  controleMaquinasViewMode: `${LOCAL_GLOBAL}:controleMaquinasViewMode`,
  financeiroPeriodoView: `${LOCAL_GLOBAL}:financeiroPeriodoView`,
  boxDeclaracaoReciboAberto: `${LOCAL_GLOBAL}:boxDeclaracaoReciboAberto`,
};

const resetStorages = () => {
  localStorage.removeItem(storage.user);
  localStorage.removeItem(storage.token);
  localStorage.removeItem(storage.accessToken);
  localStorage.removeItem(storage.refreshToken);
  localStorage.removeItem(storage.regAtividade);
  localStorage.removeItem(storage.colheita);
  localStorage.removeItem(storage.medidaPadrao);
  localStorage.removeItem(storage.regMdo);
  localStorage.removeItem(storage.tutorial);
  localStorage.removeItem(storage.filtersFinancialSearch);
  localStorage.removeItem(storage.filtersFinancialPeriod);
  localStorage.removeItem(storage.filtersFinancial);
  localStorage.removeItem(storage.filtersFinancialPagination);
  localStorage.removeItem(storage.filtersFinancialPaginationConta);
  localStorage.removeItem(storage.vendasSortBy);
  localStorage.removeItem(storage.vendasSortOrder);
  localStorage.removeItem(storage.fazendaAtivaId);
  // A visão FAZENDA/VIVEIRO é de quem estava olhando (ver utils/visao.js). Se
  // ficasse, uma conta só de fazenda que entra depois cairia no cardápio do
  // viveiro, sem o alternador para voltar.
  localStorage.removeItem(`${LOCAL_GLOBAL}:visao`);

  Object.keys(localStorage).forEach((key) => {
    if (key.startsWith(`${storage.filtersFinancialPaginationConta}_`)) {
      localStorage.removeItem(key);
    }
  });
};

const resetRegAtividade = () => {
  localStorage.removeItem(storage.regAtividade);
};

export { LOCAL_GLOBAL, storage, resetStorages, resetRegAtividade };
